import classNames from 'classnames';
import EcoLink from 'eco-design/base/eco-link';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { Fragment } from 'react';
import './index.scss';
export default function Content({ id, data = {} }: any) {
    const { position, list = [] } = data;
    const { locale, asPath } = useRouter();
    const pathnameA = `/${locale}${asPath}`;

    return (
        <GloLayout className={`editor-blog-button-items editor-blog-button-items-position-${position}`} id={id}>
            {list.map((item: any, index: number) => {
                const cssType = item.cssType;
                const prefixCls = 'editor-blog-button-items-item';
                const compCls = classNames(prefixCls, {
                    [`${prefixCls}-css-${cssType}`]: cssType,
                });
                const btnText = item.btnText || '';
                const btnHref = item.btnHref || '';
                if (!btnText || !btnHref) {
                    return null;
                }
                const dataLayerShopify = {
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: btnText,
                    position: `blog_${pathnameA}`,
                };
                const dataLayerWWW = {
                    event: 'uaEvent',
                    event_name: 'select_product',
                    list_name: 'none',
                    product_name: btnText,
                    button_name: `${btnText || ''}_blog`,
                };
                const dataLayer = btnHref.includes('www.ecoflow.com') ? dataLayerWWW : dataLayerShopify;
                return (
                    <Fragment key={index}>
                        <EcoLink className={compCls} href={item.btnHref} dataLayer={dataLayer}>
                            {item.btnText}
                        </EcoLink>
                    </Fragment>
                );
            })}
        </GloLayout>
    );
}
